export const isNormalInteger = (str) => /^\+?(0|[1-9]\d*)$/.test(str);
export const isValidEmail = (str) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(str);
